<template>
  <div class="main-conent main-conent-maxheight main-content-rows">
    <div class="main-content-cols">
      <div class="main-content-cols__body" v-loading="loading">
        <carousel :loading="loading" :data="curData"></carousel>

        <search
          @date-change="dateChange"
          @type-change="typeChange"
          @export="exportExcel"
        ></search>

        <div class="custom-cols" v-show="type === 'preview'">
          <div class="box-card" style="width:500px;height: 400px;">
            <div class="head-title">
              赤霉病
            </div>

            <el-form
              v-loading="loadingGibble"
              label-width="140px"
              label-position="left"
              :model="gibble"
            >
              <el-form-item label="指导意⻅">
                <span>{{ gibble.guidance }}</span>
              </el-form-item>
              <el-form-item label="扬花期开始时间">
                <el-date-picker
                  v-model="gibble.floweringStartTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="扬花期结束时间">
                <el-date-picker
                  v-model="gibble.floweringEndTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item>
                <el-button
                  type="primary"
                  :disabled="!gibbleChanged"
                  @click="setGibble"
                >
                  设 置
                </el-button>
                <el-button :disabled="!gibbleChanged" @click="resetGibble">
                  取 消
                </el-button>
              </el-form-item>

              <el-form-item scope-slot="error" v-if="gibbleError">
                <span class="text-danger">{{ gibbleError }}</span>
              </el-form-item>
            </el-form>
          </div>

          <div class="box-card" style="width:500px;height: 400px;">
            <div class="head-title">
              白粉病
            </div>

            <el-form label-width="140px" label-position="left" :model="powdery">
              <el-form-item label="指导意⻅">
                <span>{{ powdery.guidance || '-' }}</span>
              </el-form-item>
              <el-form-item label="抽穗期">
                <el-date-picker
                  v-model="powdery.headingTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item>
                <el-button
                  type="primary"
                  :disabled="!powderyChanged"
                  @click="setPowdery"
                >
                  设 置
                </el-button>
                <el-button :disabled="!powderyChanged" @click="resetPowdery">
                  取 消
                </el-button>
              </el-form-item>

              <el-form-item scope-slot="error" v-if="powderyError">
                <span class="text-danger">{{ powderyError }}</span>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <el-row v-show="type === 'data'" :gutter="20">
          <el-col>
            <data-list
              v-if="reload"
              v-loading="loadingList"
              ref="table"
              :cols="listCols"
              :data="weatherList"
              :height="height"
            ></data-list>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
// import Echart from '@/components/Chart'
import DataList from './components/dataList'
import Carousel from './components/list'
import Search from './components/search'
import {
  weather,
  info,
  getDevices,
  getPredict,
  setGibble,
  setPowdery
} from '@/service/epidemic'
import { getIcon } from '@/utlis/meteorology'
import sleep from '@/utlis/sleep'

export default {
  components: { Carousel, DataList, Search },
  data() {
    return {
      loadingList: false, // 初始化列数据
      loading: false,
      reload: true, // 用于刷新 el-table 高度
      type: 'preview', // 显示的类型
      devs: [],
      actived: 0,
      cols: [],
      curData: [],
      height: 600,
      query: {
        begin: moment()
          .startOf('month')
          .format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      }, // 查询参数。用于在设备切换时保留查询参数
      loadingGibble: false,
      gibble: {
        floweringStartTime: '',
        floweringEndTime: '',
        predictResult: 0,
        guidance: ''
      },
      bkGibble: {},
      gibbleError: '',
      loadingPowdery: false,
      powderyError: '',
      powdery: {
        headingTime: '',
        predictResult: 0,
        guidance: ''
      },
      bkPowdery: {},
      weatherList: []
    }
  },
  computed: {
    dev() {
      return this.devs[this.actived]
    },
    listCols() {
      return this.cols.filter(c => c.alias)
    },
    gibbleChanged() {
      return !(
        this.gibble.floweringStartTime === this.bkGibble.floweringStartTime &&
        this.gibble.floweringEndTime === this.bkGibble.floweringEndTime
      )
    },
    powderyChanged() {
      return this.powdery.headingTime !== this.bkPowdery.headingTime
    }
  },
  async mounted() {
    this.height = this.$el.offsetHeight - 118 - 93 - 60
    this.initData()
  },
  methods: {
    async initData() {
      this.loading = true

      const { data } = await getDevices(this.companyId)
      this.devs = data

      this.$nextTick(() => {
        this.getInfo(this.dev.id)
      })
    },
    async getInfo(id) {
      this.loading = true
      if (id) {
        const [{ data }, ret1, ret2] = await Promise.all([
          info(this.companyId, id),
          getPredict(this.dev.id, this.companyId, 2),
          getPredict(this.dev.id, this.companyId, 3),
          sleep(1)
        ])
        this.gibble = ret1.data
        this.gibbleError = ''
        this.bkGibble = { ...this.gibble }
        this.powdery = ret2.data
        this.bkPowdery = { ...this.powdery }
        this.powderyError = ''
        this.cols = data
        this.curData = data.map(d => {
          const icon = getIcon(d.name)
          return {
            ...icon,
            ...d,
            value: d.value || '-'
          }
        })
      }
      this.loading = false
    },
    async getWeather(begin, end) {
      this.loadingList = true
      const { data } = await weather(this.companyId, this.dev.id, begin, end)
      this.weatherList = data
      this.loadingList = false
    },
    async dateChange(begin, end) {
      this.query = { begin, end }
      this.getWeather(begin, end)
    },
    typeChange(type) {
      this.type = type
      if (type === 'data' && !this.weatherList[0]) {
        const { begin, end } = this.query
        this.getWeather(begin, end)
      }
    },
    exportExcel(title) {
      this.$refs.table.exportExcel(title)
    },
    async setGibble() {
      const body = {
        id: this.gibble.id,
        companyId: this.companyId,
        startDate: this.gibble.floweringStartTime,
        endDate: this.gibble.floweringEndTime
      }

      this.loadingGibble = true
      const { data } = await setGibble(this.dev.id, body)

      if (typeof data === 'string') {
        // this.$message.error(data)
        this.gibbleError = data
      } else {
        this.gibble = data
        this.bkGibble = { ...data }
        this.gibbleError = ''
      }

      this.loadingGibble = false
    },
    resetGibble() {
      this.gibble = { ...this.bkGibble }
      this.gibbleError = ''
    },
    async setPowdery() {
      this.loadingPowdery = true
      const { data } = await setPowdery(this.dev.id, {
        id: this.powdery.id,
        companyId: this.companyId,
        headingTime: this.powdery.headingTime
      })

      if (typeof data === 'string') {
        this.powderyError = data
      } else {
        this.powdery = data
        this.bkPowdery = { ...data }
        this.powderyError = ''
      }

      this.loadingPowdery = false
    },
    resetPowdery() {
      this.powdery = { ...this.bkPowdery }
      this.powderyError = ''
    }
  },
  watch: {
    // 监控高度刷新 el-table 高度
    height() {
      this.reload = false
      this.$nextTick(() => {
        this.reload = true
      })
    }
  }
}
</script>

<style lang="scss">
// .mete-data-container {
//   height: 100%;
// }
.custom-cols {
  display: flex;
  .box-card {
    margin-left: 20px;
  }
  .head-title {
    font-size: 1.2rem;
    padding-bottom: 12px;
    border-bottom: 1px solid #d1d1d1;
    margin-bottom: 32px;
    box-sizing: border-box;
  }
}
</style>
